module.exports = __webpack_public_path__ + "static/image6-ce9b37401436b57aabc7c794b9648a74.jpg";